import React, { useContext, useState, useEffect, useReducer, useRef, memo, useCallback } from "react";
import { isSameDay, parseISO, format } from "date-fns";
import clsx from "clsx";
import { isNil } from "lodash";
import { blue, green, red } from "@material-ui/core/colors";
import {
  Button,
  CircularProgress,
  Divider,
  IconButton,
  makeStyles,
  Badge
} from "@material-ui/core";

import {
  AccessTime,
  Block,
  Done,
  DoneAll,
  ExpandMore,
  GetApp,
  Facebook,
  Instagram,
  RateReview,
  Reply,
  Close,
  Translate,
} from "@material-ui/icons";

import MarkdownWrapper from "../MarkdownWrapper";
import VcardPreview from "../VcardPreview";
import LocationPreview from "../LocationPreview";
import ModalImageCors from "../ModalImageCors";
import MessageOptionsMenu from "../MessageOptionsMenu";
import whatsBackground from "../../assets/wa-background.png";
import whatsBackgroundDark from "../../assets/wa-background-dark.png";
import YouTubePreview from "../ModalYoutubeCors";

import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";

import { Popper, Paper, ClickAwayListener } from "@material-ui/core";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import api from "../../services/api";
import toastError from "../../errors/toastError";
// import { SocketContext } from "../../context/Socket/SocketContext";
import { i18n } from "../../translate/i18n";
import SelectMessageCheckbox from "./SelectMessageCheckbox";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import { AuthContext } from "../../context/Auth/AuthContext";
import { QueueSelectedContext } from "../../context/QueuesSelected/QueuesSelectedContext";
import AudioModal from "../AudioModal";
import AdMetaPreview from "../AdMetaPreview"; // Adicionado componente de preview de anÃºncio
import SaveFieldFromTextMenu from "../SaveFieldFromTextMenu";
import MessageCoachNotesDialog from "../MessageCoachNotesDialog";
import { hasEmbeddedSignature } from "../../utils/messageSignature";
import { toast } from "react-toastify";

import { messages } from "../../translate/languages";
import { useParams, useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  messagesListWrapper: {
    overflow: "hidden",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    width: "100%",
    minWidth: 300,
    minHeight: 200,
  },

  saveFieldFab: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    padding: "6px 14px",
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    borderRadius: 20,
    cursor: "pointer",
    fontSize: 13,
    fontWeight: 500,
    boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
    zIndex: 9999,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },

  currentTick: {
    alignItems: "center",
    textAlign: "center",
    alignSelf: "center",
    width: "95%",
    backgroundColor: theme.palette.primary.main,
    margin: "10px",
    borderRadius: "10px",
    boxShadow: "1px 5px 10px #b3b3b3",
  },

  currentTicktText: {
    color: theme.palette.primary,
    fontWeight: 'bold',
    padding: 8,
    alignSelf: "center",
    marginLeft: "0px",
  },

  messagesList: {
    backgroundImage: theme.mode === 'light' ? `url(${whatsBackground})` : `url(${whatsBackgroundDark})`,
    backgroundColor: theme.mode === 'light' ? "transparent" : "#0b0b0d",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: "20px 20px 72px 20px",
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  dragElement: {
    background: 'rgba(255, 255, 255, 0.8)',
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: 999999,
    textAlign: "center",
    fontSize: "3em",
    border: "5px dashed #333",
    color: '#333',
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  circleLoading: {
    color: blue[500],
    position: "absolute",
    opacity: "70%",
    top: 0,
    left: "50%",
    marginTop: 12,
  },

  messageLeft: {
    marginRight: 20,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },

    whiteSpace: "pre-wrap",
    backgroundColor: theme.mode === 'light' ? "#ffffff" : "#202c33",
    color: theme.mode === 'light' ? "#303030" : "#ffffff",
    alignSelf: "flex-start",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    boxShadow: theme.mode === 'light' ? "0 1px 1px #b3b3b3" : "0 1px 1px #000000"
  },

  quotedContainerLeft: {
    margin: "-3px -80px 6px -6px",
    overflow: "hidden",
    backgroundColor: theme.mode === 'light' ? "#f0f0f0" : "#1d282f",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  quotedMsg: {
    padding: 10,
    maxWidth: 300,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },

  quotedSideColorLeft: {
    flex: "none",
    width: "4px",
    backgroundColor: "#388aff",
  },

  messageRight: {
    marginLeft: 20,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },
    whiteSpace: "pre-wrap",
    backgroundColor: theme.mode === 'light' ? "#dcf8c6" : "#005c4b",
    color: theme.mode === 'light' ? "#303030" : "#ffffff",
    alignSelf: "flex-end",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 0,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    boxShadow: theme.mode === 'light' ? "0 1px 1px #b3b3b3" : "0 1px 1px #000000"
  },

  messageRightPrivate: {
    marginLeft: 20,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },
    whiteSpace: "pre-wrap",
    backgroundColor: "#F0E68C",
    color: "#303030",
    alignSelf: "flex-end",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 0,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    boxShadow: theme.mode === 'light' ? "0 1px 1px #b3b3b3" : "0 1px 1px #000000"
  },

  quotedContainerRight: {
    margin: "-3px -80px 6px -6px",
    overflowY: "hidden",
    backgroundColor: theme.mode === 'light' ? "#cfe9ba" : "#025144",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  quotedMsgRight: {
    padding: 10,
    maxWidth: 300,
    height: "auto",
    whiteSpace: "pre-wrap",
  },

  quotedSideColorRight: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },

  messageActionsButton: {
    display: "none",
    position: "relative",
    color: "#999",
    zIndex: 1,
    backgroundColor: "inherit",
    opacity: "90%",
    "&:hover, &.Mui-focusVisible": { backgroundColor: "inherit" },
  },

  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },

  textContentItem: {
    overflowWrap: "break-word",
    padding: "3px 80px 6px 6px",
  },

  textContentItemWithReadReceipt: {
    paddingBottom: 28,
  },

  textContentItemDeleted: {
    fontStyle: "italic",
    color: "rgba(0, 0, 0, 0.36)",
    overflowWrap: "break-word",
    padding: "3px 80px 6px 6px",
  },

  messageMedia: {
    objectFit: "cover",
    width: 400,
    height: "auto",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },

  timestamp: {
    fontSize: 11,
    position: "absolute",
    bottom: 3,
    right: 5,
    color: "#999",
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: 2,
    maxWidth: "calc(100% - 18px)"
  },

  readReceiptInfo: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    marginLeft: 6,
    fontSize: 10,
    color: theme.mode === "light" ? "#4f6b7a" : "#9ec6d8",
    fontWeight: 500,
    whiteSpace: "nowrap",
  },

  forwardMessage: {
    fontSize: 12,
    fontStyle: "italic",
    position: "absolute",
    top: 0,
    left: 5,
    color: "#999",
    display: "flex",
    alignItems: "center"
  },

  translatedIndicator: {
    fontSize: 11,
    color: theme.mode === "light" ? "#667781" : "#c7d1d8",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: 4,
    marginTop: 4,
    padding: "3px 0 1px",
    borderTop: theme.mode === "light" ? "1px solid rgba(0,0,0,0.06)" : "1px solid rgba(255,255,255,0.12)",
    userSelect: "none",
    "&:hover": {
      textDecoration: "underline",
    }
  },

  translatedIcon: {
    fontSize: 14,
  },

  transcribeBtn: {
    fontSize: 11,
    color: theme.mode === "light" ? "#667781" : "#c7d1d8",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: 4,
    marginTop: 4,
    padding: "3px 0 1px",
    userSelect: "none",
    "&:hover": {
      textDecoration: "underline",
    }
  },

  mediaInlineActions: {
    display: "flex",
    gap: 12,
    flexWrap: "wrap",
    alignItems: "center",
    marginTop: 4,
  },

  transcriptionText: {
    fontSize: 12,
    color: theme.mode === "light" ? "#303030" : "#f5f7f8",
    marginTop: 4,
    padding: "6px 8px",
    backgroundColor: theme.mode === "light" ? "rgba(0,0,0,0.04)" : "rgba(255,255,255,0.08)",
    borderRadius: 6,
    lineHeight: 1.4,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },

  transcriptionLang: {
    fontSize: 10,
    color: theme.mode === "light" ? "#667781" : "#c7d1d8",
    marginTop: 2,
    fontStyle: "italic",
  },

  dailyTimestamp: {
    alignItems: "center",
    textAlign: "center",
    alignSelf: "center",
    width: "110px",
    backgroundColor: "#e1f3fb",
    margin: "10px",
    borderRadius: "10px",
    boxShadow: "0 1px 1px #b3b3b3",
  },

  dailyTimestampText: {
    color: "#808888",
    padding: 8,
    alignSelf: "center",
    marginLeft: "0px",
  },

  ackIcons: {
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },

  deletedIcon: {
    fontSize: 18,
    verticalAlign: "middle",
    marginRight: 4,
  },

  ackDoneAllIcon: {
    color: blue[500],
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },

  ackPlayedIcon: {
    color: green[500],
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },
  downloadMedia: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "inherit",
    padding: 10,
    color: theme.mode === "light" ? theme.palette.light : theme.palette.dark,
  },

  messageCenter: {
    marginTop: 5,
    alignItems: "center",
    verticalAlign: "center",
    alignContent: "center",
    backgroundColor: "#E1F5FEEB",
    fontSize: "12px",
    minWidth: 100,
    maxWidth: 270,
    color: "#272727",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    boxShadow: "0 1px 1px #b3b3b3",
  },

  deletedMessage: {
    color: '#f55d65'
  },

  reactionBadge: {
    position: "absolute",
    bottom: -10,
    right: 10,
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    padding: "2px 8px",
    borderRadius: 12,
    fontSize: 14,
    lineHeight: 1,
    backgroundColor: theme.mode === "light" ? "#ffffff" : "#111b21",
    color: theme.mode === "light" ? "#303030" : "#f5f7f8",
    border: theme.mode === "light" ? "1px solid rgba(0,0,0,0.12)" : "1px solid rgba(255,255,255,0.16)",
    boxShadow: theme.mode === "light" ? "0 1px 2px rgba(0,0,0,0.16)" : "0 1px 2px rgba(0,0,0,0.45)",
    zIndex: 2
  },

  reactionBadgeCount: {
    fontSize: 11,
    opacity: 0.8
  },

  coachIndicator: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    marginLeft: 8,
    padding: "6px 12px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 700,
    color: theme.mode === "dark" ? "#eef7ff" : "#0b3b5c",
    background: theme.mode === "dark" ? "rgba(78, 169, 255, 0.24)" : "rgba(92, 184, 255, 0.30)",
    border: theme.mode === "dark" ? "1px solid rgba(120, 198, 255, 0.68)" : "1px solid rgba(92, 184, 255, 0.45)",
    cursor: "pointer",
    userSelect: "none",
    appearance: "none",
    outline: "none",
    fontFamily: "inherit",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    boxShadow: theme.mode === "dark" ? "0 0 0 1px rgba(120, 198, 255, 0.14)" : "none",
    transition: "transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease, color 0.15s ease",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: theme.mode === "dark" ? "0 4px 16px rgba(49, 132, 209, 0.28)" : "0 4px 14px rgba(39, 120, 180, 0.25)",
      background: theme.mode === "dark" ? "rgba(78, 169, 255, 0.34)" : "rgba(92, 184, 255, 0.42)"
    },
    "&:focus": {
      boxShadow: "0 0 0 3px rgba(92, 184, 255, 0.25)"
    }
  },

  coachIndicatorActive: {
    animation: "$coachPulseSoft 1.4s ease-in-out infinite"
  },

  coachIndicatorPending: {
    color: theme.mode === "dark" ? "#fff8dc" : "#5d3d00",
    background: theme.mode === "dark" ? "rgba(255, 196, 61, 0.22)" : "rgba(255, 202, 40, 0.40)",
    border: theme.mode === "dark" ? "1px solid rgba(255, 214, 102, 0.92)" : "1px solid rgba(255, 202, 40, 0.75)",
    boxShadow: theme.mode === "dark"
      ? "0 0 0 2px rgba(255, 196, 61, 0.14), 0 0 18px rgba(255, 196, 61, 0.22)"
      : "0 0 0 2px rgba(255, 202, 40, 0.16)",
    animation: "$coachPulse 1.05s ease-in-out infinite"
  },

  messageCoachFocus: {
    boxShadow: theme.mode === "dark"
      ? "0 0 0 2px rgba(255, 196, 61, 0.72), 0 0 22px rgba(255, 196, 61, 0.24), 0 1px 1px #000000"
      : "0 0 0 2px rgba(255, 196, 61, 0.55), 0 0 18px rgba(255, 196, 61, 0.20), 0 1px 1px #b3b3b3",
    transition: "box-shadow 0.24s ease, transform 0.24s ease",
    transform: "translateY(-1px)"
  },

  messageAgentSignature: {
    display: "block",
    borderLeft: "3px solid #06cf9c",
    paddingLeft: 6,
    marginBottom: 6,
    color: "#06cf9c",
    fontWeight: 500,
    fontSize: "0.8rem"
  },

  "@keyframes coachPulse": {
    "0%": {
      transform: "scale(1)",
      boxShadow: theme.mode === "dark"
        ? "0 0 0 2px rgba(255, 196, 61, 0.14), 0 0 0 0 rgba(255, 196, 61, 0.12)"
        : "0 0 0 2px rgba(255, 202, 40, 0.16), 0 0 0 0 rgba(255, 202, 40, 0.12)"
    },
    "50%": {
      transform: "scale(1.035)",
      boxShadow: theme.mode === "dark"
        ? "0 0 0 2px rgba(255, 196, 61, 0.18), 0 0 0 8px rgba(255, 196, 61, 0.08)"
        : "0 0 0 2px rgba(255, 202, 40, 0.18), 0 0 0 8px rgba(255, 202, 40, 0.08)"
    },
    "100%": {
      transform: "scale(1)",
      boxShadow: theme.mode === "dark"
        ? "0 0 0 2px rgba(255, 196, 61, 0.14), 0 0 0 0 rgba(255, 196, 61, 0)"
        : "0 0 0 2px rgba(255, 202, 40, 0.16), 0 0 0 0 rgba(255, 202, 40, 0)"
    }
  },

  "@keyframes coachPulseSoft": {
    "0%": {
      transform: "scale(1)",
      boxShadow: theme.mode === "dark"
        ? "0 0 0 1px rgba(120, 198, 255, 0.14), 0 0 0 0 rgba(120, 198, 255, 0.10)"
        : "0 0 0 1px rgba(92, 184, 255, 0.10), 0 0 0 0 rgba(92, 184, 255, 0.08)"
    },
    "50%": {
      transform: "scale(1.03)",
      boxShadow: theme.mode === "dark"
        ? "0 0 0 1px rgba(120, 198, 255, 0.18), 0 0 0 8px rgba(120, 198, 255, 0.08)"
        : "0 0 0 1px rgba(92, 184, 255, 0.14), 0 0 0 8px rgba(92, 184, 255, 0.06)"
    },
    "100%": {
      transform: "scale(1)",
      boxShadow: theme.mode === "dark"
        ? "0 0 0 1px rgba(120, 198, 255, 0.14), 0 0 0 0 rgba(120, 198, 255, 0)"
        : "0 0 0 1px rgba(92, 184, 255, 0.10), 0 0 0 0 rgba(92, 184, 255, 0)"
    }
  }
}));

const sortMessagesByCreatedAt = (items) => {
  return [...items].sort((left, right) => {
    const leftTime = left?.createdAt ? new Date(left.createdAt).getTime() : 0;
    const rightTime = right?.createdAt ? new Date(right.createdAt).getTime() : 0;

    if (leftTime !== rightTime) {
      return leftTime - rightTime;
    }

    return Number(left?.id || 0) - Number(right?.id || 0);
  });
};

const isOptimisticMessageMatch = (existingMessage, incomingMessage) => {
  if (!existingMessage || !incomingMessage) return false;
  if (!String(existingMessage.id || "").startsWith("tmp-")) return false;
  if (!existingMessage.fromMe || !incomingMessage.fromMe) return false;
  if (String(existingMessage.body || "").trim() !== String(incomingMessage.body || "").trim()) return false;

  const existingTime = existingMessage?.createdAt ? new Date(existingMessage.createdAt).getTime() : 0;
  const incomingTime = incomingMessage?.createdAt ? new Date(incomingMessage.createdAt).getTime() : 0;

  if (!existingTime || !incomingTime) return true;

  return Math.abs(existingTime - incomingTime) <= 5 * 60 * 1000;
};

const reducer = (state, action) => {
  console.log("ðŸ”„ [MessagesList Reducer] AÃ§Ã£o recebida:", action.type, "Payload:", action.payload);
  console.log("ðŸ”„ [MessagesList Reducer] Estado atual tem", state.length, "mensagens");

  if (action.type === "LOAD_MESSAGES") {
    const messages = action.payload;
    const nextState = [...state];

    messages.forEach((message) => {
      const messageIndex = nextState.findIndex((m) => m.id === message.id);
      if (messageIndex !== -1) {
        nextState[messageIndex] = message;
      } else {
        const optimisticIndex = nextState.findIndex((m) => isOptimisticMessageMatch(m, message));
        if (optimisticIndex !== -1) {
          nextState[optimisticIndex] = message;
        } else {
          nextState.push(message);
        }
      }
    });

    const newState = sortMessagesByCreatedAt(nextState);
    console.log("âœ… [MessagesList Reducer] LOAD_MESSAGES completado. Novo estado tem", newState.length, "mensagens");
    return newState;
  }

  if (action.type === "ADD_MESSAGE") {
    const newMessage = action.payload;
    const messageIndex = state.findIndex((m) => m.id === newMessage.id);

    if (messageIndex !== -1) {
      state[messageIndex] = newMessage;
    } else {
      const optimisticIndex = state.findIndex((m) => isOptimisticMessageMatch(m, newMessage));
      if (optimisticIndex !== -1) {
        state[optimisticIndex] = newMessage;
      } else {
        state.push(newMessage);
      }
    }

    console.log("âœ… [MessagesList Reducer] ADD_MESSAGE completado. Novo estado tem", state.length, "mensagens");
    return sortMessagesByCreatedAt([...state]);
  }

  if (action.type === "UPDATE_MESSAGE") {
    const messageToUpdate = action.payload;
    const messageIndex = state.findIndex((m) => m.id === messageToUpdate.id);

    if (messageIndex !== -1) {
      state[messageIndex] = messageToUpdate;
    }

    console.log("âœ… [MessagesList Reducer] UPDATE_MESSAGE completado");
    return sortMessagesByCreatedAt([...state]);
  }

  if (action.type === "DELETE_MESSAGE") {
    const messageId = action.payload;
    const newState = sortMessagesByCreatedAt(state.filter((m) => m.id !== messageId));
    console.log("âœ… [MessagesList Reducer] DELETE_MESSAGE completado. Removeu", state.length - newState.length, "mensagem(ns)");
    return newState;
  }

  if (action.type === "REMOVE_TEMP_MESSAGE") {
    const messageId = action.payload;
    return sortMessagesByCreatedAt(state.filter((m) => m.id !== messageId));
  }

  if (action.type === "RESET") {
    console.log("ðŸ”„ [MessagesList Reducer] RESET completado. Estado zerado.");
    return [];
  }
};

const MessagesList = ({
  isGroup,
  onDrop,
  whatsappId,
  queueId,
  channel,
  contactId,
  ticket
}) => {
  const classes = useStyles();
  const [messagesList, dispatch] = useReducer(reducer, []);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const history = useHistory();
  const lastMessageRef = useRef();
  const messagesContainerRef = useRef(null);
  const autoScrollEnabledRef = useRef(true);
  const lastRenderedMessageRef = useRef(null);

  const [selectedMessage, setSelectedMessage] = useState({});
  const [coachDialogOpen, setCoachDialogOpen] = useState(false);
  const [coachDialogMessage, setCoachDialogMessage] = useState(null);
  const [coachSummaryByMessage, setCoachSummaryByMessage] = useState({});
  const [focusedCoachMessageId, setFocusedCoachMessageId] = useState(null);
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const messageOptionsMenuOpen = Boolean(anchorEl);
  const { ticketId } = useParams();

  const [selectionText, setSelectionText] = useState("");
  const [selectionAnchorEl, setSelectionAnchorEl] = useState(null);
  const [saveFieldOpen, setSaveFieldOpen] = useState(false);
  const selectionVirtualRef = useRef(null);

  const currentTicketId = useRef(ticketId);
  const { getAll } = useCompanySettings();
  const [dragActive, setDragActive] = useState(false);
  const [showOriginal, setShowOriginal] = useState({});
  const [transcriptions, setTranscriptions] = useState({});
  const [transcribing, setTranscribing] = useState({});
  const autoProcessedMediaRef = useRef({});
  const syncInFlightRef = useRef(false);
  const socketRefreshTimeoutRef = useRef(null);

  const [lgpdDeleteMessage, setLGPDDeleteMessage] = useState(false);
  const { selectedQueuesMessage } = useContext(QueueSelectedContext);

  const { showSelectMessageCheckbox } = useContext(ForwardMessageContext);

  const { user, socket } = useContext(AuthContext);
  const orderedMessagesList = React.useMemo(
    () => sortMessagesByCreatedAt(messagesList),
    [messagesList]
  );
  const reactionsByTargetMessage = React.useMemo(() => {
    const grouped = new Map();

    orderedMessagesList.forEach(message => {
      if (message?.mediaType !== "reactionMessage" || !message?.quotedMsg?.id) {
        return;
      }

      const targetId = message.quotedMsg.id;
      const current = grouped.get(targetId) || [];
      current.push({
        id: message.id,
        emoji: message.body,
        fromMe: message.fromMe,
        contactName: message?.contact?.name || ""
      });
      grouped.set(targetId, current);
    });

    return grouped;
  }, [orderedMessagesList]);

  const renderAgentSignature = (message) => {
    if (!message?.fromMe) return null;

    const fallbackSignature = String(
      message.agentSignature ||
      ticket?.user?.signature ||
      ticket?.user?.name ||
      ""
    ).trim();

    if (!fallbackSignature) return null;
    if (hasEmbeddedSignature(message.body || "")) return null;

    return (
      <span className={classes.messageAgentSignature}>
        {fallbackSignature}
      </span>
    );
  };

  const renderCoachIndicator = (message) => {
    const summary = coachSummaryByMessage[message?.id];

    if (!summary?.count) {
      return null;
    }

    return (
      <button
        type="button"
        className={clsx(classes.coachIndicator, {
          [classes.coachIndicatorActive]: Number(summary.count || 0) > 0,
          [classes.coachIndicatorPending]: Number(summary.myPendingCount || 0) > 0
        })}
        title={`${summary.count} anotaciones internas${summary.myPendingCount ? ` · ${summary.myPendingCount} pendientes para usted` : ""}`}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          openCoachDialog(message);
        }}
        onMouseDown={(event) => {
          event.stopPropagation();
        }}
      >
        <RateReview style={{ fontSize: 15 }} />
        {summary.myPendingCount ? `Coach pendiente (${summary.myPendingCount})` : `Coach (${summary.count})`}
      </button>
    );
  };

  const companyId = user.companyId;

  const loadCoachSummary = useCallback(async () => {
    if (!ticket?.id) {
      setCoachSummaryByMessage({});
      return;
    }

    try {
      const { data } = await api.get(`/tickets/${ticket.id}/message-coach-summary`);
      const nextSummary = {};
      (data?.items || []).forEach(item => {
        nextSummary[item.messageId] = item;
      });
      setCoachSummaryByMessage(nextSummary);
    } catch (_error) {
      // summary is secondary; keep chat usable even if this request fails
    }
  }, [ticket?.id]);

  const openCoachDialog = useCallback((message) => {
    if (!message) return;
    setCoachDialogMessage(message);
    setCoachDialogOpen(true);
  }, []);

  const scrollToMessageById = useCallback((messageId) => {
    if (!messageId) {
      return;
    }

    setFocusedCoachMessageId(Number(messageId));

    let attempts = 0;

    const runScroll = () => {
      attempts += 1;
      const element = document.querySelector(`[data-message-id="${messageId}"]`);
      if (element && element.scrollIntoView) {
        element.scrollIntoView({ behavior: attempts === 1 ? "smooth" : "auto", block: "center" });
        return;
      }

      if (attempts < 8) {
        window.setTimeout(runScroll, 180);
      }
    };

    window.requestAnimationFrame(runScroll);

    window.setTimeout(() => {
      setFocusedCoachMessageId(current => (Number(current) === Number(messageId) ? null : current));
    }, 9000);
  }, []);

  const closeCoachDialog = useCallback(() => {
    const targetMessageId = Number(coachDialogMessage?.id || 0);
    setCoachDialogOpen(false);

    if (targetMessageId) {
      window.setTimeout(() => {
        scrollToMessageById(targetMessageId);
      }, 180);
    }
  }, [coachDialogMessage?.id, scrollToMessageById]);

  useEffect(() => {

    async function fetchData() {

      const settings = await getAll(companyId);

      let settinglgpdDeleteMessage;
      let settingEnableLGPD;

      for (const [key, value] of Object.entries(settings)) {

        if (key === "lgpdDeleteMessage") settinglgpdDeleteMessage = value
        if (key === "enableLGPD") settingEnableLGPD = value
      }
      if (settingEnableLGPD === "enabled" && settinglgpdDeleteMessage === "enabled") {
        setLGPDDeleteMessage(true);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);

    currentTicketId.current = ticketId;
  }, [ticketId, selectedQueuesMessage]);

  useEffect(() => {
    loadCoachSummary();
  }, [loadCoachSummary]);

  useEffect(() => {
    console.log("ðŸ” [MessagesList] useEffect disparado - ticketId:", ticketId, "pageNumber:", pageNumber);
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchMessages = async () => {
        if (ticketId === "undefined") {
          console.log("âš ï¸ [MessagesList] ticketId Ã© 'undefined', redirecionando...");
          history.push("/tickets");
          return;
        }
        if (isNil(ticketId)) {
          console.log("âš ï¸ [MessagesList] ticketId Ã© nil/null, abortando...");
          return;
        }
        try {
          console.log("ðŸ“¡ [MessagesList] Fazendo requisiÃ§Ã£o para:", "/messages/" + ticketId);
          const { data } = await api.get("/messages/" + ticketId, {
            params: { pageNumber, selectedQueues: JSON.stringify(selectedQueuesMessage) },
          });

          console.log("âœ… [MessagesList] Resposta recebida:", {
            messagesCount: data.messages?.length,
            hasMore: data.hasMore,
            ticketInfo: data.ticket
          });

          if (currentTicketId.current === ticketId) {
            console.log("ðŸ“¥ [MessagesList] Despachando LOAD_MESSAGES com", data.messages?.length, "mensagens");
            dispatch({ type: "LOAD_MESSAGES", payload: data.messages });
            setHasMore(data.hasMore);
            setLoading(false);
            setLoadingMore(false);

            // Carregar transcriÃ§Ãµes jÃ¡ salvas no banco
            const savedTranscriptions = {};
            data.messages.forEach((msg) => {
              if (msg.transcription) {
                try {
                  const parsed = JSON.parse(msg.transcription);
                  savedTranscriptions[msg.id] = {
                    transcribedText: parsed.transcribedText || null,
                    translatedText: parsed.translatedText || null,
                    detectedLanguage: parsed.detectedLanguage || null,
                    extractedText: parsed.extractedText || null,
                    summaryText: parsed.summaryText || null,
                    showOriginal: false,
                  };
                } catch (e) {}
              }
            });
            if (Object.keys(savedTranscriptions).length > 0) {
              setTranscriptions(prev => ({ ...prev, ...savedTranscriptions }));
            }
          }

          if (pageNumber === 1 && data.messages.length > 1) {
            scrollToBottom();
          }
        } catch (err) {
          setLoading(false);
          toastError(err);
          setLoadingMore(false);
        }
      };

      fetchMessages();
    }, 500);
    return () => {
      clearTimeout(delayDebounceFn);
    };
  }, [pageNumber, ticketId, selectedQueuesMessage]);

  const reloadLatestMessagesSnapshot = useCallback(async () => {
    if (ticketId === "undefined" || isNil(ticketId) || syncInFlightRef.current) {
      return;
    }

    syncInFlightRef.current = true;

    try {
      const { data } = await api.get(`/messages/${ticketId}`, {
        params: { pageNumber: 1, selectedQueues: JSON.stringify(selectedQueuesMessage) },
      });

      if (currentTicketId.current === ticketId) {
        dispatch({ type: "LOAD_MESSAGES", payload: data.messages || [] });
        setHasMore(data.hasMore);
      }
    } catch (_err) {
    } finally {
      syncInFlightRef.current = false;
    }
  }, [ticketId, selectedQueuesMessage]);

  const scheduleLatestMessagesSnapshot = useCallback((delay = 250) => {
    if (socketRefreshTimeoutRef.current) {
      clearTimeout(socketRefreshTimeoutRef.current);
    }

    socketRefreshTimeoutRef.current = setTimeout(() => {
      reloadLatestMessagesSnapshot();
    }, delay);
  }, [reloadLatestMessagesSnapshot]);

  useEffect(() => {
    if (ticketId === "undefined" || isNil(ticketId)) {
      return undefined;
    }

    const syncLatestMessages = async () => {
      if (document.hidden) {
        return;
      }

      await reloadLatestMessagesSnapshot();
    };

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        syncLatestMessages();
      }
    };

    const intervalId = setInterval(syncLatestMessages, 3000);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [ticketId, selectedQueuesMessage, reloadLatestMessagesSnapshot]);

  useEffect(() => {
    orderedMessagesList.forEach((message) => {
      if (!message?.id || message.fromMe || message.mediaType !== "audio") return;
      if (transcriptions[message.id]?.transcribedText || transcriptions[message.id]?.translatedText) return;
      if (transcribing[message.id]) return;
      if (autoProcessedMediaRef.current[message.id]) return;

      autoProcessedMediaRef.current[message.id] = true;
      handleTranscribeAudio(message);
    });
  }, [orderedMessagesList, transcriptions, transcribing]);

  useEffect(() => {
    if (ticketId === "undefined") {
      return;
    }

    const companyId = user.companyId;

    // âœ… CORREÃ‡ÃƒO: Usar ticketId (UUID) diretamente
    const connectEventMessagesList = () => {
      socket.emit("joinChatBox", ticketId);
    }

    const onAppMessageMessagesList = (data) => {
      const eventTicketUuid = data?.ticket?.uuid || data?.message?.ticket?.uuid || null;
      const eventTicketId = Number(
        data?.ticket?.id ||
        data?.message?.ticketId ||
        data?.message?.ticket?.id ||
        0
      );
      const currentNumericTicketId = Number(ticket?.id || 0);
      const belongsToCurrentTicket =
        (eventTicketUuid && eventTicketUuid === ticketId) ||
        (eventTicketId && currentNumericTicketId && eventTicketId === currentNumericTicketId);

      if (data?.action === "create" || data?.action === "update") {
        console.log("[MessagesList socket]", {
          openTicketId: ticketId,
          openNumericTicketId: currentNumericTicketId,
          action: data?.action,
          eventTicketUuid,
          eventTicketId,
          messageId: data?.message?.id || null
        });
      }

      if (data?.action === "create" && eventTicketUuid && eventTicketUuid !== ticketId && (!eventTicketId || eventTicketId !== currentNumericTicketId)) {
        console.log("[MessagesList socket mismatch]", {
          openTicketId: ticketId,
          eventTicketUuid,
          eventTicketId,
          messageId: data?.message?.id || null
        });
      }

      if (data.action === "create" && belongsToCurrentTicket) {
        dispatch({ type: "ADD_MESSAGE", payload: data.message });
        scrollToBottom(!data?.message?.fromMe);
        scheduleLatestMessagesSnapshot(180);
      }

      if (data.action === "update" && belongsToCurrentTicket) {
        dispatch({ type: "UPDATE_MESSAGE", payload: data.message });
        scheduleLatestMessagesSnapshot(180);
      }

      if (data.action == "delete" && belongsToCurrentTicket) {
        dispatch({ type: "DELETE_MESSAGE", payload: data.messageId });
        scheduleLatestMessagesSnapshot(180);
      }
    };

    const onCoachNoteEvent = (data) => {
      const eventTicketUuid = data?.ticketUuid || data?.note?.ticket?.uuid || null;
      const eventTicketId = Number(data?.note?.ticketId || data?.note?.ticket?.id || 0);
      const currentNumericTicketId = Number(ticket?.id || 0);
      const belongsToCurrentTicket =
        (eventTicketUuid && eventTicketUuid === ticketId) ||
        (eventTicketId && currentNumericTicketId && eventTicketId === currentNumericTicketId);

      if (belongsToCurrentTicket) {
        loadCoachSummary();
      }

      const targetUserId = Number(data?.targetUserId || data?.note?.targetUserId || 0);
      const authorUserId = Number(data?.note?.authorUserId || 0);

      if (data?.action === "created" && targetUserId === Number(user?.id || 0) && authorUserId !== Number(user?.id || 0)) {
        const pendingPayload = {
          ticketUuid: eventTicketUuid,
          messageId: Number(data?.note?.messageId || 0),
          noteId: Number(data?.note?.id || 0),
          createdAt: Date.now()
        };

        localStorage.setItem("soluwhats:pendingCoachMessage", JSON.stringify(pendingPayload));

        if (belongsToCurrentTicket) {
          const targetMessage = orderedMessagesList.find(item => Number(item.id) === Number(data?.note?.messageId || 0));
          if (targetMessage) {
            openCoachDialog(targetMessage);
            scrollToMessageById(targetMessage.id);
          }
        }

        toast.info(
          `Nueva anotaciÃ³n interna de ${data?.note?.authorUser?.name || "administraciÃ³n"}`,
          {
            autoClose: 7000,
            onClick: () => {
              if (eventTicketUuid && history.location.pathname !== `/tickets/${eventTicketUuid}`) {
                history.push(`/tickets/${eventTicketUuid}`);
                return;
              }

              const targetMessage = orderedMessagesList.find(item => Number(item.id) === Number(data?.note?.messageId || 0));
              if (targetMessage) {
                openCoachDialog(targetMessage);
                scrollToMessageById(targetMessage.id);
              }
            }
          }
        );
      }
    };
    socket.on("connect", connectEventMessagesList);
    socket.on(`company-${companyId}-appMessage`, onAppMessageMessagesList);
    socket.on(`company-${companyId}-message-coach-note`, onCoachNoteEvent);

    return () => {
      socket.emit("joinChatBoxLeave", ticketId);

      if (socketRefreshTimeoutRef.current) {
        clearTimeout(socketRefreshTimeoutRef.current);
        socketRefreshTimeoutRef.current = null;
      }

      socket.off("connect", connectEventMessagesList);
      socket.off(`company-${companyId}-appMessage`, onAppMessageMessagesList);
      socket.off(`company-${companyId}-message-coach-note`, onCoachNoteEvent);
    };

  }, [ticketId, ticket?.id, user.companyId, user?.id, socket, reloadLatestMessagesSnapshot, scheduleLatestMessagesSnapshot, loadCoachSummary, history, orderedMessagesList, openCoachDialog, scrollToMessageById]);

  useEffect(() => {
    const handleOptimisticMessage = (event) => {
      const detail = event?.detail;
      if (!detail || detail.ticketId !== ticketId) {
        return;
      }

      dispatch({ type: "ADD_MESSAGE", payload: detail.message });
      scrollToBottom(true);
    };

    const handleOptimisticMessageRollback = (event) => {
      const detail = event?.detail;
      if (!detail || detail.ticketId !== ticketId || !detail.messageId) {
        return;
      }

      dispatch({ type: "REMOVE_TEMP_MESSAGE", payload: detail.messageId });
    };

    window.addEventListener("soluwhats:optimistic-message", handleOptimisticMessage);
    window.addEventListener("soluwhats:optimistic-message-rollback", handleOptimisticMessageRollback);

    return () => {
      window.removeEventListener("soluwhats:optimistic-message", handleOptimisticMessage);
      window.removeEventListener("soluwhats:optimistic-message-rollback", handleOptimisticMessageRollback);
    };
  }, [ticketId]);

  useEffect(() => {
    if (!ticketId || !orderedMessagesList.length) {
      return;
    }

    const rawPending = localStorage.getItem("soluwhats:pendingCoachMessage");
    if (!rawPending) {
      return;
    }

    try {
      const pending = JSON.parse(rawPending);
      if (!pending?.ticketUuid || pending.ticketUuid !== ticketId) {
        return;
      }

      const targetMessage = orderedMessagesList.find(item => Number(item.id) === Number(pending.messageId || 0));
      if (!targetMessage) {
        return;
      }

      openCoachDialog(targetMessage);
      scrollToMessageById(targetMessage.id);
      localStorage.removeItem("soluwhats:pendingCoachMessage");
    } catch (_error) {
      localStorage.removeItem("soluwhats:pendingCoachMessage");
    }
  }, [ticketId, orderedMessagesList, openCoachDialog, scrollToMessageById]);

  const loadMore = () => {
    if (loadingMore) return;
    setLoadingMore(true);
    setPageNumber((prevPageNumber) => prevPageNumber + 1);
  };

const isNearBottom = () => {
  const messagesContainer = messagesContainerRef.current;
  if (!messagesContainer) return true;

  const distanceFromBottom =
    messagesContainer.scrollHeight -
    messagesContainer.scrollTop -
    messagesContainer.clientHeight;

  return distanceFromBottom < 180;
};

const scrollToBottom = (force = false) => {
  setTimeout(() => {
    const messagesContainer = messagesContainerRef.current;

    if (!messagesContainer) {
      return;
    }

    if (!force && !autoScrollEnabledRef.current && !isNearBottom()) {
      return;
    }

    messagesContainer.scrollTop = messagesContainer.scrollHeight;

    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({ block: "end" });
    }
  }, 60);
};

const handleScroll = (e) => {
  const { scrollTop } = e.currentTarget;
  autoScrollEnabledRef.current = isNearBottom();

  if (scrollTop === 0) {
    e.currentTarget.scrollTop = 1;
  }

  if (loading) {
    return;
  }

  if (hasMore && scrollTop < 50) {
    loadMore();
  }
};

useEffect(() => {
  const lastMessage = orderedMessagesList[orderedMessagesList.length - 1];

  if (!lastMessage) {
    return;
  }

  const renderKey = `${lastMessage.id}-${lastMessage.updatedAt || lastMessage.createdAt || ""}`;
  const previousRenderKey = lastRenderedMessageRef.current;
  const isNewRenderedMessage = previousRenderKey !== renderKey;

  lastRenderedMessageRef.current = renderKey;

  if (isNewRenderedMessage) {
    const shouldForceScroll = !previousRenderKey || lastMessage.fromMe;
    scrollToBottom(shouldForceScroll);
  }
}, [orderedMessagesList]);

const handleTextSelection = useCallback(() => {
  const selection = window.getSelection();
  const text = selection ? selection.toString().trim() : "";

  if (text.length >= 3 && contactId) {
    const range = selection.getRangeAt(0);
    const rect = range.getBoundingClientRect();
    selectionVirtualRef.current = {
      getBoundingClientRect: () => rect,
      clientWidth: rect.width,
      clientHeight: rect.height,
    };
    setSelectionText(text);
    setSelectionAnchorEl(selectionVirtualRef.current);
  } else {
    setSelectionAnchorEl(null);
    setSelectionText("");
  }
}, [contactId]);

const handleOpenMessageOptionsMenu = (e, message) => {
  setAnchorEl(e.currentTarget);
  setSelectedMessage(message);
};

const handleCloseMessageOptionsMenu = (e) => {
  setAnchorEl(null);
};

const hanldeReplyMessage = (e, message) => {
  //if (ticket.status === "open" || ticket.status === "group") {
  setAnchorEl(null);
  setReplyingMessage(message);
  //}
};

const checkMessageMedia = (message) => {
  console.log(message)
  if (message.mediaType === "locationMessage" && message.body.split('|').length >= 2) {
    let locationParts = message.body.split('|')
    let imageLocation = locationParts[0]
    let linkLocation = locationParts[1]

    let descriptionLocation = null

    if (locationParts.length > 2)
      descriptionLocation = message.body.split('|')[2]

    return <LocationPreview image={imageLocation} link={linkLocation} description={descriptionLocation} />
  } else

    if (message.mediaType === "contactMessage") {
      let array = message.body.split("\n");
      let obj = [];
      let contact = "";
      for (let index = 0; index < array.length; index++) {
        const v = array[index];
        let values = v.split(":");
        for (let ind = 0; ind < values.length; ind++) {
          if (values[ind].indexOf("+") !== -1) {
            obj.push({ number: values[ind] });
          }
          if (values[ind].indexOf("FN") !== -1) {
            contact = values[ind + 1];
          }
        }
      }
      // console.log(message)
      return <VcardPreview contact={contact} numbers={obj[0]?.number} queueId={message?.ticket?.queueId} whatsappId={message?.ticket?.whatsappId} />
    } else if (message.mediaType === "adMetaPreview") { // Adicionado para renderizar o componente de preview de anÃºncio
  let [image, sourceUrl, title, body] = message.body.split('|');
  let messageUser = i18n.t("messagesResponsive.ads.defaultUserMessage");
  return <AdMetaPreview image={image} sourceUrl={sourceUrl} title={title} body={body} messageUser={messageUser} />;
}

      if (message.mediaType === "image") {
        return (
          <>
            <ModalImageCors imageUrl={message.mediaUrl} />
            <div className={classes.mediaInlineActions}>
              <Button
                size="small"
                startIcon={<GetApp />}
                variant="outlined"
                target="_blank"
                href={message.mediaUrl}
              >
                Descargar imagen
              </Button>
            </div>
            {renderImageInsight(message)}
          </>
        );
      } else

        if (message.mediaType === "audio") {
          return (
            <>
              <AudioModal url={message.mediaUrl} />
              {renderAudioTranscription(message)}
            </>
          );
        } else

          if (message.mediaType === "video") {
            return (
              <video
                className={classes.messageMedia}
                src={message.mediaUrl}
                controls
              />
            );
          } else {
            return (
              <>
                <div className={classes.downloadMedia}>
                  <Button
                    startIcon={<GetApp />}
                    variant="outlined"
                    target="_blank"
                    href={message.mediaUrl}
                  >
                    {i18n.t("messagesResponsive.actions.download")}
                  </Button>
                </div>
                <Divider />
              </>
            );
          }
};

const renderMessageAck = (message) => {
  if (message.ack === 0) {
    return <AccessTime fontSize="small" className={classes.ackIcons} />;
  } else
    if (message.ack === 1) {
      return <Done fontSize="small" className={classes.ackIcons} />;
    } else
      if (message.ack === 2) {
        return <DoneAll fontSize="small" className={classes.ackIcons} />;
      } else
        if (message.ack === 3 || message.ack === 4) {
          return <DoneAll fontSize="small" className={message.mediaType === "audio" ? classes.ackPlayedIcon : classes.ackDoneAllIcon} />;
        } else
          if (message.ack === 5) {
            return <DoneAll fontSize="small" className={classes.ackDoneAllIcon} />
          }
};

const renderReadReceiptInfo = (message) => {
  if (!message?.fromMe || !message?.readAt || Number(message?.ack || 0) < 3) {
    return null;
  }

  try {
    const fullLabel = format(parseISO(message.readAt), "dd/MM/yyyy HH:mm:ss");

    return (
      <span className={classes.readReceiptInfo} title={`Leido ${fullLabel}`}>
        <DoneAll style={{ fontSize: 13, color: blue[500] }} />
        Leido {fullLabel}
      </span>
    );
  } catch (error) {
    return null;
  }
};

const hasReadReceipt = (message) => Boolean(
  message?.fromMe &&
  message?.readAt &&
  Number(message?.ack || 0) >= 3
);

const renderDailyTimestamps = (message, index) => {
  const today = format(new Date(), "dd/MM/yyyy")

  if (index === 0) {
    return (
      <span
        className={classes.dailyTimestamp}
        key={`timestamp-${message.id}`}
      >
        <div className={classes.dailyTimestampText}>
          {today === format(parseISO(orderedMessagesList[index].createdAt), "dd/MM/yyyy") ? i18n.t("messagesResponsive.timestamp.today") : format(parseISO(orderedMessagesList[index].createdAt), "dd/MM/yyyy")}
        </div>
      </span>
    );
  } else
    if (index < orderedMessagesList.length - 1) {
      let messageDay = parseISO(orderedMessagesList[index].createdAt);
      let previousMessageDay = parseISO(orderedMessagesList[index - 1].createdAt);

      if (!isSameDay(messageDay, previousMessageDay)) {
        return (
          <span
            className={classes.dailyTimestamp}
            key={`timestamp-${message.id}`}
          >
            <div className={classes.dailyTimestampText}>
              {today === format(parseISO(orderedMessagesList[index].createdAt), "dd/MM/yyyy") ? i18n.t("messagesResponsive.timestamp.today") : format(parseISO(orderedMessagesList[index].createdAt), "dd/MM/yyyy")}
            </div>
          </span>
        );
      }
    } else
      if (index === orderedMessagesList.length - 1) {
        return (
          <div
            key={`ref-${message.id}`}
            style={{ float: "left", clear: "both" }}
          />
        );
      }
};


  const renderTicketsSeparator = (message, index) => {
  let lastTicket = orderedMessagesList[index - 1]?.ticketId;
  let currentTicket = message.ticketId;

  if (lastTicket !== currentTicket && lastTicket !== undefined) {
    if (message?.ticket?.queue) {
      return (
        <span
          className={classes.currentTick}
          key={`timestamp-${message.id}a`}
        >
          <div
            className={classes.currentTicktText}
            style={{ backgroundColor: message?.ticket?.queue?.color || "grey" }}
          >
            #{i18n.t("ticketsList.called")} {message?.ticketId} - {message?.ticket?.queue?.name}
          </div>

        </span>
      );
    } else {
      return (
        <span
          className={classes.currentTick}
          key={`timestamp-${message.id}b`}
        >
          <div
            className={classes.currentTicktText}
            style={{ backgroundColor: "grey" }}
          >
            #{i18n.t("ticketsList.called")} {message.ticketId} - {i18n.t("ticketsList.noQueue")}
          </div>

        </span>
      );
    }
  }

};

const renderMessageDivider = (message, index) => {
  if (index < orderedMessagesList.length && index > 0) {
    let messageUser = orderedMessagesList[index].fromMe;
    let previousMessageUser = orderedMessagesList[index - 1].fromMe;
    if (messageUser !== previousMessageUser) {
      return (

        <span style={{ marginTop: 16 }} key={`divider-${message.id}`}></span>
      );
    }
  }
};

const path = require('path');

// Helper para obter o corpo da mensagem (com suporte a traduÃ§Ã£o)
const getMessageBody = (message) => {
  // Mensagens recebidas (fromMe=false): translatedBody = traduÃ§Ã£o para idioma do atendente
  // Mensagens enviadas (fromMe=true): body = texto original do atendente, translatedBody = o que foi enviado traduzido
  if (message.translatedBody && !message.fromMe) {
    // Mensagem recebida traduzida: mostra traduÃ§Ã£o por padrÃ£o
    return showOriginal[message.id] ? message.body : message.translatedBody;
  }
  return message.body;
};

const toggleOriginal = (messageId) => {
  setShowOriginal(prev => ({ ...prev, [messageId]: !prev[messageId] }));
};

const handleTranscribeAudio = async (message) => {
  if (transcribing[message.id]) return;

  // Extract filename from mediaUrl
  const url = message.mediaUrl || "";
  const fileName = url.split("/").pop();
  if (!fileName) return;

  setTranscribing(prev => ({ ...prev, [message.id]: true }));
  try {
    const { data } = await api.get(`/messages/transcribeAudio/${encodeURIComponent(fileName)}`);
    setTranscriptions(prev => ({
      ...prev,
      [message.id]: {
        transcribedText: data.transcribedText,
        translatedText: data.translatedText,
        detectedLanguage: data.detectedLanguage,
        showOriginal: false,
      }
    }));
  } catch (err) {
    toastError(err);
  }
  setTranscribing(prev => ({ ...prev, [message.id]: false }));
};

const handleExtractImageText = async (message) => {
  if (transcribing[message.id]) return;

  const url = message.mediaUrl || "";
  const fileName = url.split("/").pop();
  if (!fileName) return;

  setTranscribing(prev => ({ ...prev, [message.id]: true }));
  try {
    const { data } = await api.get(`/messages/extractImageText/${encodeURIComponent(fileName)}`);
    setTranscriptions(prev => ({
      ...prev,
      [message.id]: {
        ...(prev[message.id] || {}),
        extractedText: data.extractedText,
        summaryText: data.summaryText,
        detectedLanguage: data.detectedLanguage,
      }
    }));
  } catch (err) {
    toastError(err);
  }
  setTranscribing(prev => ({ ...prev, [message.id]: false }));
};

const renderAudioTranscription = (message) => {
  const t = transcriptions[message.id];
  if (!t) {
    return (
      <span
        className={classes.transcribeBtn}
        onClick={() => handleTranscribeAudio(message)}
      >
        {transcribing[message.id] ? (
          <>
            <CircularProgress size={12} />
            {i18n.t("messagesResponsive.transcription.transcribing")}
          </>
        ) : (
          <>
            <Translate className={classes.translatedIcon} />
            {i18n.t("messagesResponsive.transcription.transcribe")}
          </>
        )}
      </span>
    );
  }

  // Mostra o texto traduzido (se disponÃ­vel) ou o transcrito original,
  // mas mantÃ©m uma aÃ§Ã£o visÃ­vel para evitar a sensaÃ§Ã£o de que el botÃ³n desapareciÃ³.
  const displayText = t.translatedText || t.transcribedText;

  return (
    <div>
      <span
        className={classes.transcribeBtn}
        onClick={() => handleTranscribeAudio(message)}
      >
        <Translate className={classes.translatedIcon} />
        Transcripcion disponible
      </span>
      <div className={classes.transcriptionText}>
        {displayText}
      </div>
    </div>
  );
};

const renderImageInsight = (message) => {
  const t = transcriptions[message.id];
  if (!t?.extractedText && !t?.summaryText) {
    return (
      <div className={classes.mediaInlineActions}>
        <span
          className={classes.transcribeBtn}
          onClick={() => handleExtractImageText(message)}
        >
          {transcribing[message.id] ? (
            <>
              <CircularProgress size={12} />
              Analizando imagen...
            </>
          ) : (
            <>
              <Translate className={classes.translatedIcon} />
              Extraer texto de la imagen
            </>
          )}
        </span>
      </div>
    );
  }

  return (
    <div>
      <div className={classes.mediaInlineActions}>
        <span
          className={classes.transcribeBtn}
          onClick={() => handleExtractImageText(message)}
        >
          <Translate className={classes.translatedIcon} />
          Texto detectado disponible
        </span>
      </div>
      {t.extractedText ? (
        <div className={classes.transcriptionText}>
          {t.extractedText}
        </div>
      ) : null}
      {t.summaryText ? (
        <div className={classes.transcriptionText}>
          {t.summaryText}
        </div>
      ) : null}
    </div>
  );
};

const renderTranslationIndicator = (message) => {
  if (!message.translatedBody) return null;

  if (!message.fromMe) {
    // Mensagem recebida traduzida
    const isShowingOriginal = showOriginal[message.id];
    const langLabel = message.originalLanguage || "?";
    return (
      <span
        className={classes.translatedIndicator}
        onClick={() => toggleOriginal(message.id)}
      >
        <Translate className={classes.translatedIcon} />
        {isShowingOriginal
          ? i18n.t("messagesResponsive.translation.showTranslation") || "Ver traduÃ§Ã£o"
          : (i18n.t("messagesResponsive.translation.translatedFrom") || "Traduzido de") + " " + langLabel}
      </span>
    );
  } else {
    // Mensagem enviada traduzida: mostrar o que foi enviado ao contato
    const isShowingTranslated = showOriginal[message.id];
    return (
      <span
        className={classes.translatedIndicator}
        onClick={() => toggleOriginal(message.id)}
      >
        <Translate className={classes.translatedIcon} />
        {isShowingTranslated
          ? i18n.t("messagesResponsive.translation.showOriginal") || "Ver original"
          : i18n.t("messagesResponsive.translation.autoTranslated") || "TraduÃ§Ã£o automÃ¡tica enviada"}
      </span>
    );
  }
};

const renderQuotedMessage = (message) => {

  return (
    <div
      className={clsx(classes.quotedContainerLeft, {
        [classes.quotedContainerRight]: message.fromMe,
      })}
    >
      <span
        className={clsx(classes.quotedSideColorLeft, {
          [classes.quotedSideColorRight]: message.quotedMsg?.fromMe,
        })}
      ></span>
      <div className={classes.quotedMsg}>
        {!message.quotedMsg?.fromMe && (
          <span className={classes.messageContactName}>
            {message.quotedMsg?.contact?.name}
          </span>
        )}

        {message.quotedMsg.mediaType === "audio"
          && (
            <div className={classes.downloadMedia}>
              <AudioModal url={message.quotedMsg.mediaUrl} />

              {/* <audio controls>
                  <source src={message.quotedMsg.mediaUrl} type="audio/mp3"></source>
                  {/* <source src={message.quotedMsg.mediaUrl} type="audio/ogg"></source> 
                </audio> */}
            </div>
          )
        }
        {message.quotedMsg.mediaType === "video"
          && (
            <video
              className={classes.messageMedia}
              src={message.quotedMsg.mediaUrl}
              controls
            />
          )
        }
        {message.quotedMsg.mediaType === "contactMessage"
          && (
            i18n.t("messagesResponsive.types.contact")
          )
        }
        {message.quotedMsg.mediaType === "application"
          && (
            <div className={classes.downloadMedia}>
              <Button
                startIcon={<GetApp />}
                // color="primary"
                variant="outlined"
                target="_blank"
                href={message.quotedMsg.mediaUrl}
              >
                {i18n.t("messagesResponsive.actions.download")}
              </Button>
            </div>
          )
        }

        {message.quotedMsg.mediaType === "image"
          && (
            <ModalImageCors imageUrl={message.quotedMsg.mediaUrl} />)
          || message.quotedMsg?.body}

        {!message.quotedMsg.mediaType === "image" && message.quotedMsg?.body}


      </div>
    </div>
  );
};

const handleDrag = event => {
  event.preventDefault();
  event.stopPropagation();
  if (event.type === "dragenter" || event.type === "dragover") {
    setDragActive(true);
  } else if (event.type === "dragleave") {
    setDragActive(false);
  }
}

const isYouTubeLink = (url) => {
  const youtubeRegex = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  return youtubeRegex.test(url);
};

const handleDrop = event => {
  event.preventDefault();
  event.stopPropagation();
  setDragActive(false);
  if (event.dataTransfer.files && event.dataTransfer.files[0]) {
    if (onDrop) {
      onDrop(event.dataTransfer.files);
    }
  }
}
const xmlRegex = /<([^>]+)>/g;
const boldRegex = /\*(.*?)\*/g;

const formatXml = (xmlString) => {
  // Verifica se o XML contÃ©m a assinatura com nome do atendente
  if (boldRegex.test(xmlString)) {
    // Formata o texto dentro da assinatura em negrito
    xmlString = xmlString.replace(boldRegex, "**$1**");
  }
  return xmlString;
};

const renderMessages = () => {
  console.log("ðŸŽ¨ [MessagesList] renderMessages chamado. messagesList.length:", messagesList.length);

  if (messagesList.length > 0) {
    console.log("ðŸŽ¨ [MessagesList] Renderizando", messagesList.length, "mensagens");
    const viewMessagesList = orderedMessagesList.map((message, index) => {
      if (message.mediaType === "reactionMessage" && message.quotedMsg?.id) {
        return null;
      }

      const messageReactions = reactionsByTargetMessage.get(message.id) || [];
      const reactionSummary = messageReactions.reduce((accumulator, reaction) => {
        const existing = accumulator.find(item => item.emoji === reaction.emoji);
        if (existing) {
          existing.count += 1;
        } else {
          accumulator.push({ emoji: reaction.emoji, count: 1 });
        }
        return accumulator;
      }, []);

      if (message.mediaType === "call_log") {
        return (
          <React.Fragment key={message.id}>
            {renderDailyTimestamps(message, index)}
            {renderTicketsSeparator(message, index)}
            {renderMessageDivider(message, index)}
            <div className={classes.messageCenter}>
              <IconButton
                variant="contained"
                size="small"
                id="messageActionsButton"
                disabled={message.isDeleted}
                className={classes.messageActionsButton}
                onClick={(e) => handleOpenMessageOptionsMenu(e, message)}
              >
                <ExpandMore />
              </IconButton>
              {isGroup && (
                <span className={classes.messageContactName}>
                  {message.contact?.name}
                </span>
              )}

              {/* {isGroup && (
                  <span className={classes.messageContactName}>
                    {JSON.parse(message.dataJson).pushName} #{message.contact?.name}
                  </span>
                )} */}
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 17" width="20" height="17">
                  <path fill="#df3333" d="M18.2 12.1c-1.5-1.8-5-2.7-8.2-2.7s-6.7 1-8.2 2.7c-.7.8-.3 2.3.2 2.8.2.2.3.3.5.3 1.4 0 3.6-.7 3.6-.7.5-.2.8-.5.8-1v-1.3c.7-1.2 5.4-1.2 6.4-.1l.1.1v1.3c0 .2.1.4.2.6.1.2.3.3.5.4 0 0 2.2.7 3.6.7.2 0 1.4-2 .5-3.1zM5.4 3.2l4.7 4.6 5.8-5.7-.9-.8L10.1 6 6.4 2.3h2.5V1H4.1v4.8h1.3V3.2z"></path>
                </svg> <span>{i18n.t("ticketsList.missedCall")} {format(parseISO(message.createdAt), "HH:mm")}</span>
              </div>
            </div>
          </React.Fragment>
        );
      }

      if (!message.fromMe) {
        return (
          <React.Fragment key={message.id}>
            {renderDailyTimestamps(message, index)}
            {renderTicketsSeparator(message, index)}
            {renderMessageDivider(message, index)}
            <div
              className={clsx(classes.messageLeft, {
                [classes.messageCoachFocus]: Number(focusedCoachMessageId || 0) === Number(message.id || 0)
              })}
              data-message-id={message.id}
              title={message.queueId && message.queue?.name}
              onDoubleClick={(e) => hanldeReplyMessage(e, message)}
            >
              {showSelectMessageCheckbox && (
                <SelectMessageCheckbox
                  // showSelectMessageCheckbox={showSelectMessageCheckbox}
                  message={message}
                // selectedMessagesList={selectedMessagesList}
                // setSelectedMessagesList={setSelectedMessagesList}
                />
              )}
              <IconButton
                variant="contained"
                size="small"
                id="messageActionsButton"
                disabled={message.isDeleted}
                className={classes.messageActionsButton}
                onClick={(e) => handleOpenMessageOptionsMenu(e, message)}
              >
                <ExpandMore />
              </IconButton>

              {message.isForwarded && (
                <div>
                  <span className={classes.forwardMessage}
                  ><Reply style={{ color: "grey", transform: 'scaleX(-1)' }} /> {i18n.t("messagesResponsive.status.forwarded")}
                  </span>
                  <br />
                </div>
              )}
              {isGroup && (
                <span className={classes.messageContactName}>
                  {message.contact?.name}
                </span>
              )}
              {isYouTubeLink(message.body) && (
                <>
                  <YouTubePreview videoUrl={message.body} />
                </>
              )}
              {/* {isGroup && (
                  <span className={classes.messageContactName}>
                    {JSON.parse(message.dataJson).pushName} #{message.contact?.name}
                  </span>
                )} */}

              {/* aviso de mensagem apagado pelo contato */}

              {!lgpdDeleteMessage && message.isDeleted && (
                <div>
                  <span className={classes.deletedMessage}
                  >{i18n.t("messagesResponsive.status.deletedByContact")} &nbsp;
                  </span>
                </div>
              )}

               {(message.mediaUrl || message.mediaType === "locationMessage" || message.mediaType === "contactMessage" || message.mediaType === "template" || message.mediaType === "adMetaPreview" // Adicionado para aceitar o componente de preview de anÃºncio
                //|| message.mediaType === "multi_vcard" 
              ) && checkMessageMedia(message)}

              <div className={clsx(classes.textContentItem, {
                [classes.textContentItemDeleted]: message.isDeleted,
                [classes.textContentItemWithReadReceipt]: hasReadReceipt(message),
              })}>
                {message.quotedMsg && renderQuotedMessage(message)}
                {
  message.mediaType !== "adMetaPreview" && (
    (
      (message.mediaUrl !== null && (message.mediaType === "image" || message.mediaType === "video") && path.basename(message.mediaUrl).trim() !== message.body.trim()) ||
      message.mediaType !== "audio" &&
      message.mediaType !== "image" &&
      message.mediaType !== "video" &&
      message.mediaType != "reactionMessage" &&
      message.mediaType != "locationMessage" &&
      message.mediaType !== "contactMessage"
    ) && (
      <>
        {xmlRegex.test(message.body) && (
          <span>{getMessageBody(message)}</span>
        )}
        {!xmlRegex.test(message.body) && (
          <MarkdownWrapper>{(lgpdDeleteMessage && message.isDeleted) ? i18n.t("messagesResponsive.status.deletedMessage") : getMessageBody(message)}</MarkdownWrapper>
        )}
        {renderTranslationIndicator(message)}
      </>
    )
  )
}


                {message.quotedMsg && message.mediaType === "reactionMessage" && (
                  <>
                    <span style={{ marginLeft: "0px" }}>
                      <MarkdownWrapper>
                        {"" + message?.contact?.name + i18n.t("messagesResponsive.reactions.contactReacted") + message.body}
                      </MarkdownWrapper>
                    </span>
                  </>
                )}

                <span className={classes.timestamp}>
                  {message.isEdited ? i18n.t("messagesResponsive.status.edited") + " " + format(parseISO(message.createdAt), "HH:mm") : format(parseISO(message.createdAt), "HH:mm")}
                </span>
                {renderCoachIndicator(message)}
                {reactionSummary.length > 0 && (
                  <span className={classes.reactionBadge}>
                    {reactionSummary.map(reaction => (
                      <span key={`${message.id}-${reaction.emoji}`}>
                        {reaction.emoji}
                        {reaction.count > 1 ? (
                          <span className={classes.reactionBadgeCount}>{reaction.count}</span>
                        ) : null}
                      </span>
                    ))}
                  </span>
                )}
              </div>
            </div>
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment key={message.id}>
            {renderDailyTimestamps(message, index)}
            {renderTicketsSeparator(message, index)}
            {renderMessageDivider(message, index)}
            <div
              className={clsx(message.isPrivate ? classes.messageRightPrivate : classes.messageRight, {
                [classes.messageCoachFocus]: Number(focusedCoachMessageId || 0) === Number(message.id || 0)
              })}
              data-message-id={message.id}
              title={message.queueId && message.queue?.name}
              onDoubleClick={(e) => hanldeReplyMessage(e, message)}
            >
              {showSelectMessageCheckbox && (
                <SelectMessageCheckbox
                  // showSelectMessageCheckbox={showSelectMessageCheckbox}
                  message={message}
                // selectedMessagesList={selectedMessagesList}
                // setSelectedMessagesList={setSelectedMessagesList}
                />
              )}

              <IconButton
                variant="contained"
                size="small"
                id="messageActionsButton"
                disabled={message.isDeleted}
                className={classes.messageActionsButton}
                onClick={(e) => handleOpenMessageOptionsMenu(e, message)}
              >
                <ExpandMore />
              </IconButton>
              {message.isForwarded && (
                <div>
                  <span className={classes.forwardMessage}
                  ><Reply style={{ color: "grey", transform: 'scaleX(-1)' }} /> {i18n.t("messagesResponsive.status.forwarded")}
                  </span>
                  <br />
                </div>
              )}
              {isYouTubeLink(message.body) && (
                <>
                  <YouTubePreview videoUrl={message.body} />
                </>
              )}
              {!lgpdDeleteMessage && message.isDeleted && (
                <div>
                  <span className={classes.deletedMessage}
                  >{i18n.t("messagesResponsive.status.deletedByMe")} &nbsp;
                  </span>
                </div>
              )}
              {(message.mediaUrl || message.mediaType === "locationMessage" || message.mediaType === "contactMessage" || message.mediaType === "template" || message.mediaType === "adMetaPreview" // Adicionado para aceitar o componente de preview de anÃºncio
                //|| message.mediaType === "multi_vcard" 
              ) && checkMessageMedia(message)}
              {renderAgentSignature(message)}
              <div
                className={clsx(classes.textContentItem, {
                  [classes.textContentItemDeleted]: message.isDeleted,
                  [classes.textContentItemWithReadReceipt]: hasReadReceipt(message),
                })}
              >

                {/* {message.isDeleted && (`ðŸš«`)} */}



                {message.quotedMsg && renderQuotedMessage(message)}

                {
                  ((message.mediaType === "image" || message.mediaType === "video") && path.basename(message.mediaUrl) === message.body) ||
                  (message.mediaType !== "audio" && message.mediaType != "reactionMessage" && message.mediaType != "locationMessage" && message.mediaType !== "contactMessage") && (
                    <>
                      {xmlRegex.test(message.body) && (
                        <div>{formatXml(
                          message.translatedBody
                            ? (!message.fromMe
                              ? (showOriginal[message.id] ? message.body : message.translatedBody)
                              : (showOriginal[message.id] ? message.translatedBody : message.body))
                            : message.body
                        )}</div>

                      )}
                      {!xmlRegex.test(message.body) && (<MarkdownWrapper>{
                        message.translatedBody
                          ? (!message.fromMe
                            ? (showOriginal[message.id] ? message.body : message.translatedBody)
                            : (showOriginal[message.id] ? message.translatedBody : message.body))
                          : message.body
                      }</MarkdownWrapper>)}
                      {renderTranslationIndicator(message)}
                    </>
                  )}

                {message.quotedMsg && message.mediaType === "reactionMessage" && (
                  <>
                    <span style={{ marginLeft: "0px" }}>
                      <MarkdownWrapper>
                        {i18n.t("messagesResponsive.reactions.youReacted") + message.body}
                      </MarkdownWrapper>
                    </span>
                  </>
                )}

                <span className={classes.timestamp}>
                  {message.isEdited ? i18n.t("messagesResponsive.status.edited") + " " + format(parseISO(message.createdAt), "HH:mm") : format(parseISO(message.createdAt), "HH:mm")}
                  {renderMessageAck(message)}
                  {renderReadReceiptInfo(message)}
                </span>
                {renderCoachIndicator(message)}
                {reactionSummary.length > 0 && (
                  <span className={classes.reactionBadge}>
                    {reactionSummary.map(reaction => (
                      <span key={`${message.id}-${reaction.emoji}`}>
                        {reaction.emoji}
                        {reaction.count > 1 ? (
                          <span className={classes.reactionBadgeCount}>{reaction.count}</span>
                        ) : null}
                      </span>
                    ))}
                  </span>
                )}
              </div>
            </div>
          </React.Fragment>
        );
      }
    });
    return viewMessagesList;
  } else {
    return <div>{i18n.t("messagesResponsive.placeholder.sayHello")}</div>;
  }
};

return (
  <div className={classes.messagesListWrapper} onDragEnter={handleDrag}>
    {dragActive && <div className={classes.dragElement} onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}>{i18n.t("messagesResponsive.actions.dropFileHere")}</div>}

    <MessageOptionsMenu
      message={selectedMessage}
      anchorEl={anchorEl}
      menuOpen={messageOptionsMenuOpen}
      handleClose={handleCloseMessageOptionsMenu}
      isGroup={isGroup}
      whatsappId={whatsappId}
      queueId={queueId}
      contactId={contactId}
      onOpenCoachNotes={openCoachDialog}
    />
    <MessageCoachNotesDialog
      open={coachDialogOpen}
      onClose={closeCoachDialog}
      message={coachDialogMessage}
      ticket={ticket}
      currentUser={user}
      onChanged={loadCoachSummary}
    />
    <div
      id="messagesList"
      ref={messagesContainerRef}
      className={classes.messagesList}
      onScroll={handleScroll}
      onMouseUp={handleTextSelection}
    >
      {messagesList.length > 0 ?
        renderMessages()
        : []}
      <div ref={lastMessageRef} style={{ float: "left", clear: "both", height: 1, width: "100%" }} />
    </div>

    {Boolean(selectionAnchorEl) && selectionText && (
      <Popper
        open={true}
        anchorEl={selectionAnchorEl}
        placement="top"
        style={{ zIndex: 9999 }}
      >
        <ClickAwayListener onClickAway={() => { setSelectionAnchorEl(null); setSelectionText(""); }}>
          <Paper
            className={classes.saveFieldFab}
            onClick={() => { setSaveFieldOpen(true); setSelectionAnchorEl(null); }}
          >
            <SaveAltIcon style={{ fontSize: 16 }} />
            Salvar no contato
          </Paper>
        </ClickAwayListener>
      </Popper>
    )}

    <SaveFieldFromTextMenu
      open={saveFieldOpen}
      onClose={() => { setSaveFieldOpen(false); setSelectionText(""); }}
      selectedText={selectionText}
      contactId={contactId}
    />

    {(channel !== "whatsapp" && channel !== undefined) && (
      <div
        style={{
          width: "100%",
          display: "flex",
          padding: "10px",
          alignItems: "center",
          backgroundColor: "#E1F3FB",
        }}
      >
        {channel === "facebook" ? (
          <Facebook />
        ) : (
          <Instagram />
        )}

        <span>
          {i18n.t("messagesResponsive.warnings.facebookPolicy")}
        </span>
      </div>
    )}
    {loading && (
      <div>
        <CircularProgress className={classes.circleLoading} />
      </div>
    )}
  </div>
);
};

export default MessagesList;

